import axios from "axios";
import { baseUrlApiOtodis, xApiKeyOtodis } from "../../config/api/apiConfig";

class StockOtodisService {
  private axios = axios.create({
    baseURL: baseUrlApiOtodis,
    // baseURL: "http://localhost:3001",
  });
  private axiosFile = axios.create({
    baseURL: baseUrlApiOtodis,
    responseType: "json",
  });

  public setToken(token: string) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    this.axiosFile.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public async getStock(params?: {
    vehicleEngineNumber?: string;
    dealerCode?: string;
    stockUnitCode?: string;
    vehicleYear?: number;
    statusStock?: string;
    vehicleColorCode?: string;
    vehicleVariantCode?: string;
    warehouseCode?: string | null;
    liteRespone?: boolean;
  }) {
    const queries = {
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
      ...(params?.vehicleEngineNumber && {
        vehicle_engine_number: params.vehicleEngineNumber,
      }),
      ...(params?.stockUnitCode && {
        stock_unit_code: params.stockUnitCode,
      }),
      ...(params?.vehicleYear && {
        vehicle_year: params.vehicleYear,
      }),
      ...(params?.statusStock && {
        status_stock: params.statusStock,
      }),
      ...(params?.warehouseCode && {
        warehouse_code: params.warehouseCode,
      }),
      ...(params?.vehicleVariantCode && {
        vehicle_variant_code: params.vehicleVariantCode,
      }),
      ...(params?.vehicleColorCode && {
        vehicle_color_code: params.vehicleColorCode,
      }),
      ...(params?.liteRespone && {
        lite_respone: params.liteRespone,
      }),
    };
    try {
      return await this.axios.get<any>("/stock", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e?.response?.data?.error?.message);
    }
  }

  public async addSingleStock(inputData?: any) {
    try {
      return await this.axiosFile.post<any>("/stock/add", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }

  public async addMultipleStock(inputData?: any) {
    try {
      return await this.axios.post<any>("/stock/add/bulk", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.error.message);
    }
  }

  public async updateStockStatus(inputData?: any) {
    try {
      return await this.axiosFile.put<any>("/stock/lock-stock", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      console.log(e.response.data.error.message);
      throw new Error(e.response.data.error.message);
    }
  }

  public async updateStockVariant(inputData?: any) {
    try {
      return await this.axiosFile.put<any>("/stock/update/variant", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      console.log(e.response.data.error.message);
      throw new Error(e.response.data.error.message);
    }
  }

  public async updateStock(inputData?: any) {
    try {
      return await this.axiosFile.put<any>("/stock/update", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      console.log(e.response.data.error.message);
      throw new Error(e.response.data.error.message);
    }
  }

  public async saveStockWisesa(inputData?: any) {
    try {
      return await this.axios.post<any>("/stock/daya/input-sj/wisesa", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      console.log(e);
      throw new Error(e.response.data.message);
    }
  }

  public async getStockWisesa(params?: any) {
    const queries = {
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
      ...(params?.startDate && {
        start_date: params.startDate,
      }),
      ...(params?.endDate && {
        end_date: params.endDate,
      }),
    };
    try {
      return await this.axios.get<any>("/stock/daya/input-sj/wisesa", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e.response?.data?.message ?? "Error");
    }
  }

  public async saveStockMotora(inputData?: any) {
    try {
      return await this.axios.post<any>("/stock/daya/input-sj/motora", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      // console.log(e);
      throw new Error(e.response.data.message);
    }
  }

  public async fetchInvoiceStockFile(inputData?: any) {
    try {
      return await this.axios.post<any>("/stock/daya/invoice-file/get", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      // console.log(e);
      throw new Error(e.response.data.message);
    }
  }

  public async processInvoiceStockFile(inputData?: any) {
    try {
      return await this.axios.post<any>("/stock/daya/invoice-file/process", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      // console.log(e);
      throw new Error(e.response.data.message);
    }
  }
}

export const stockOtodisService = new StockOtodisService();
